/** @format */

import React, { Component } from 'react';
import transformDisplayText from 'src/helpers/transformDisplayText';
import { DEFAULT_CONTROL_FONT_SIZES } from 'src/constants/constants';
import InfoTooltip from 'src/ui/library/ToolTip/InfoTooltip';
import iconTransform from 'src/helpers/iconTransform.js';
export default class CaptionControl extends Component {
  render() {
    const labelText = transformDisplayText(
      this.props.value || this.props.label,
      DEFAULT_CONTROL_FONT_SIZES.Caption,
      this.props.increaseFontSize,
    );
    const finalText = this.props.showText === true ? labelText : '';
    const align = this.props.align === 'R' ? 'right-align' : this.props.align === 'C' ? 'center-align' : 'left-align';
    const styl =
      this.props.align === 'R'
        ? { 'text-align': 'right' }
        : this.props.align === 'C'
        ? { 'text-align': 'center' }
        : { 'text-align': 'left' };
    const largeIcon = this.props.biggerIcon === true ? 'control-icons-inline-large' : '';
    //if only icon is given and that too it is center aligned then removing custom margins added.
    const iconNoMargin = !this.props.showText && this.props.align === 'C' ? 'control-icon-no-margin' : '';
    return (
      <div className={`control-caption ${align}`}>
        {this.props.icon && (
          <div className={'control-icons control-icons-inline ' + largeIcon + ' ' + iconNoMargin}>
            <span>{iconTransform(this.props.icon, null, this.props.biggerIcon)}</span>
          </div>
        )}
        {this.props.helpText ? (
          <InfoTooltip
            style={styl}
            toolTipText={this.props.helpText}
            labelText={
              <span component="legend" style={{ color: '#2E2E38' }}>
                {finalText}
              </span>
            }
          />
        ) : this.props.showText === true ? (
          <div style={styl} className={'control-icons-inline-controls fullWidth'}>
            <span component="legend" style={{ color: '#2E2E38' }}>
              {finalText}
            </span>
          </div>
        ) : null}
      </div>
    );
  }
}
